module.exports = __webpack_public_path__ + "static/media/search.fab320ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/search.svg
// module id = 1078
// module chunks = 36